import { render, staticRenderFns } from "./CoverDetailsWidget.vue?vue&type=template&id=700b5f99&scoped=true"
import script from "./CoverDetailsWidget.vue?vue&type=script&lang=js"
export * from "./CoverDetailsWidget.vue?vue&type=script&lang=js"
import style0 from "./CoverDetailsWidget.vue?vue&type=style&index=0&id=700b5f99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b5f99",
  null
  
)

/* custom blocks */
import block0 from "./CoverDetailsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports